import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, BookOpen, Search, BarChart3 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useModules } from '../contexts/ModuleContext';

const WelcomeScreen = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { getModulesForUser } = useModules();
  const [hasAssignedModules, setHasAssignedModules] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAssignedModules = async () => {
      if (!user || !user.email) {
        setHasAssignedModules(false);
        setLoading(false);
        return;
      }

      try {
        const modules = await getModulesForUser(user);
        // Debug logging
        console.log('WelcomeScreen - User:', user.email, 'Role:', user.role);
        console.log('WelcomeScreen - Assigned modules:', modules?.length || 0, modules);
        
        // Show "My Trainings" button if user has at least one assigned module
        const hasModules = Array.isArray(modules) && modules.length > 0;
        console.log('WelcomeScreen - Has assigned modules:', hasModules);
        setHasAssignedModules(hasModules);
      } catch (error) {
        console.error('Error checking assigned modules:', error);
        setHasAssignedModules(false);
      } finally {
        setLoading(false);
      }
    };

    checkAssignedModules();
  }, [user, getModulesForUser]);

  const handlePrescreening = () => {
    // Always navigate to prescreening flow when "Help me choose" is clicked
    // Users can go through prescreening again to update their preferences
    navigate('/prescreening/level');
  };

  const handleBrowseAll = () => {
    // Navigate to dashboard with clearFilters flag
    navigate('/dashboard?clearFilters=true');
  };

  const handleMyTrainings = () => {
    navigate('/progress');
  };

  return (
    <div className="welcome-screen-container">
      <div className="welcome-content">
        <h1 className="welcome-title">Ready to start learning?</h1>
        
        <div className="welcome-actions">
          <button 
            className="welcome-btn welcome-btn-secondary"
            onClick={handlePrescreening}
          >
            <Search size={20} style={{ marginRight: '12px' }} />
            Help me choose
          </button>
          
          <button 
            className="welcome-btn welcome-btn-secondary"
            onClick={handleBrowseAll}
          >
            <BookOpen size={20} style={{ marginRight: '12px' }} />
            Browse All Modules
          </button>
          
          {!loading && hasAssignedModules && (
            <button 
              className="welcome-btn welcome-btn-secondary"
              onClick={handleMyTrainings}
            >
              <BarChart3 size={20} style={{ marginRight: '12px' }} />
              My Trainings
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;

